import React from 'react';
import './style.scss'

const ArtistsTermsAndConditions = () => {
    return (
        <div style={{tabInterval: '36.0pt', wordWrap: 'break-word', margin: '5%', paddingTop: '4rem'}}>
            <style dangerouslySetInnerHTML={{
                __html: `
                                 /* Font Definitions */
                                 @font-face
                                	{font-family:"Cambria Math";
                                	panose-1:2 4 5 3 5 4 6 3 2 4;
                                	mso-font-charset:0;
                                	mso-generic-font-family:roman;
                                	mso-font-pitch:variable;
                                	mso-font-signature:-536870145 1107305727 0 0 415 0;}
                                @font-face
                                	{font-family:DengXian;
                                	panose-1:2 1 6 0 3 1 1 1 1 1;
                                	mso-font-alt:等线;
                                	mso-font-charset:134;
                                	mso-generic-font-family:auto;
                                	mso-font-pitch:variable;
                                	mso-font-signature:-1610612033 953122042 22 0 262159 0;}
                                @font-face
                                	{font-family:Calibri;
                                	panose-1:2 15 5 2 2 2 4 3 2 4;
                                	mso-font-charset:0;
                                	mso-generic-font-family:swiss;
                                	mso-font-pitch:variable;
                                	mso-font-signature:-469750017 -1040178053 9 0 511 0;}
                                @font-face
                                	{font-family:Roboto;
                                	panose-1:2 0 0 0 0 0 0 0 0 0;
                                	mso-font-charset:0;
                                	mso-generic-font-family:auto;
                                	mso-font-pitch:variable;
                                	mso-font-signature:-536868097 1342185855 33 0 415 0;}
                                @font-face
                                	{font-family:"\\@DengXian";
                                	panose-1:2 1 6 0 3 1 1 1 1 1;
                                	mso-font-charset:134;
                                	mso-generic-font-family:auto;
                                	mso-font-pitch:variable;
                                	mso-font-signature:-1610612033 953122042 22 0 262159 0;}
                                 /* Style Definitions */
                                 p.MsoNormal, li.MsoNormal, div.MsoNormal
                                	{mso-style-unhide:no;
                                	mso-style-qformat:yes;
                                	mso-style-parent:"";
                                	margin-top:0cm;
                                	margin-right:0cm;
                                	margin-bottom:8.0pt;
                                	margin-left:0cm;
                                	line-height:107%;
                                	mso-pagination:widow-orphan;
                                	font-size:11.0pt;
                                	font-family:"Calibri",sans-serif;
                                	mso-ascii-font-family:Calibri;
                                	mso-ascii-theme-font:minor-latin;
                                	mso-fareast-font-family:DengXian;
                                	mso-fareast-theme-font:minor-fareast;
                                	mso-hansi-font-family:Calibri;
                                	mso-hansi-theme-font:minor-latin;
                                	mso-bidi-font-family:"Times New Roman";
                                	mso-bidi-theme-font:minor-bidi;
                                	mso-ansi-language:EN-GB;
                                	mso-fareast-language:EN-US;}
                                h1
                                	{mso-style-priority:9;
                                	mso-style-unhide:no;
                                	mso-style-qformat:yes;
                                	mso-style-link:"Heading 1 Char";
                                	mso-margin-top-alt:auto;
                                	margin-right:0cm;
                                	mso-margin-bottom-alt:auto;
                                	margin-left:0cm;
                                	mso-pagination:widow-orphan;
                                	mso-outline-level:1;
                                	font-size:24.0pt;
                                	font-family:"Times New Roman",serif;
                                	mso-fareast-font-family:"Times New Roman";
                                	mso-ansi-language:EN-GB;
                                	mso-fareast-language:EN-GB;
                                	font-weight:bold;}
                                h3
                                	{mso-style-priority:9;
                                	mso-style-unhide:no;
                                	mso-style-qformat:yes;
                                	mso-style-link:"Heading 3 Char";
                                	mso-margin-top-alt:auto;
                                	margin-right:0cm;
                                	mso-margin-bottom-alt:auto;
                                	margin-left:0cm;
                                	mso-pagination:widow-orphan;
                                	mso-outline-level:3;
                                	font-size:13.5pt;
                                	font-family:"Times New Roman",serif;
                                	mso-fareast-font-family:"Times New Roman";
                                	mso-ansi-language:EN-GB;
                                	mso-fareast-language:EN-GB;
                                	font-weight:bold;}
                                p
                                	{mso-style-noshow:yes;
                                	mso-style-priority:99;
                                	mso-margin-top-alt:auto;
                                	margin-right:0cm;
                                	mso-margin-bottom-alt:auto;
                                	margin-left:0cm;
                                	mso-pagination:widow-orphan;
                                	font-size:12.0pt;
                                	font-family:"Times New Roman",serif;
                                	mso-fareast-font-family:"Times New Roman";
                                	mso-ansi-language:EN-GB;
                                	mso-fareast-language:EN-GB;}
                                span.Heading1Char
                                	{mso-style-name:"Heading 1 Char";
                                	mso-style-priority:9;
                                	mso-style-unhide:no;
                                	mso-style-locked:yes;
                                	mso-style-link:"Heading 1";
                                	mso-ansi-font-size:24.0pt;
                                	mso-bidi-font-size:24.0pt;
                                	font-family:"Times New Roman",serif;
                                	mso-ascii-font-family:"Times New Roman";
                                	mso-fareast-font-family:"Times New Roman";
                                	mso-hansi-font-family:"Times New Roman";
                                	mso-bidi-font-family:"Times New Roman";
                                	mso-font-kerning:18.0pt;
                                	mso-fareast-language:EN-GB;
                                	font-weight:bold;}
                                span.Heading3Char
                                	{mso-style-name:"Heading 3 Char";
                                	mso-style-priority:9;
                                	mso-style-unhide:no;
                                	mso-style-locked:yes;
                                	mso-style-link:"Heading 3";
                                	mso-ansi-font-size:13.5pt;
                                	mso-bidi-font-size:13.5pt;
                                	font-family:"Times New Roman",serif;
                                	mso-ascii-font-family:"Times New Roman";
                                	mso-fareast-font-family:"Times New Roman";
                                	mso-hansi-font-family:"Times New Roman";
                                	mso-bidi-font-family:"Times New Roman";
                                	mso-fareast-language:EN-GB;
                                	font-weight:bold;}
                                span.apple-tab-span
                                	{mso-style-name:apple-tab-span;
                                	mso-style-unhide:no;}
                                span.SpellE
                                	{mso-style-name:"";
                                	mso-spl-e:yes;}
                                span.GramE
                                	{mso-style-name:"";
                                	mso-gram-e:yes;}
                                .MsoChpDefault
                                	{mso-style-type:export-only;
                                	mso-default-props:yes;
                                	font-size:11.0pt;
                                	mso-ansi-font-size:11.0pt;
                                	mso-bidi-font-size:11.0pt;
                                	font-family:"Calibri",sans-serif;
                                	mso-bidi-font-family:"Times New Roman";
                                	mso-bidi-theme-font:minor-bidi;
                                	mso-font-kerning:0pt;
                                	mso-ligatures:none;
                                	mso-ansi-language:EN-GB;
                                	mso-fareast-language:EN-US;}
                                .MsoPapDefault
                                	{mso-style-type:export-only;
                                	margin-bottom:8.0pt;
                                	line-height:107%;}
                                 /* Page Definitions */
                                 @page
                                	{mso-page-border-surround-header:no;
                                	mso-page-border-surround-footer:no;}
                                @page WordSection1
                                	{size:595.3pt 841.9pt;
                                	margin:72.0pt 72.0pt 72.0pt 72.0pt;
                                	mso-header-margin:35.4pt;
                                	mso-footer-margin:35.4pt;
                                	mso-paper-source:0;}
                                div.WordSection1
                                	{page:WordSection1;}
                                `
            }}/>

            <div className="WordSection1">

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '1'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '24.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFontKerning: '18.0pt',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite Artist Terms and Conditions</span></b><b><span
                    lang="EN-GB" style={{
                    fontSize: '24.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFontKerning: '18.0pt',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                {/*<p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '1'}}><b><span*/}
                {/*    lang="EN-GB" style={{*/}
                {/*    fontSize: '24.0pt',*/}
                {/*    fontFamily: '"Arial",sans-serif',*/}
                {/*    msoFareastFontFamily: '"Times New Roman"',*/}
                {/*    color: '#1F1F1F',*/}
                {/*    msoFontKerning: '18.0pt',*/}
                {/*    msoFareastLanguage: 'EN-GB'*/}
                {/*}}>Terms and Conditions</span></b><b><span lang="EN-GB"*/}
                {/*                                           style={{*/}
                {/*                                               fontSize: '24.0pt',*/}
                {/*                                               fontFamily: '"Times New Roman",serif',*/}
                {/*                                               msoFareastFontFamily: '"Times New Roman"',*/}
                {/*                                               msoFontKerning: '18.0pt',*/}
                {/*                                               msoFareastLanguage: 'EN-GB'*/}
                {/*                                           }}></span></b></p>*/}

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Updated:&nbsp; 06-Jan-26&nbsp;</span></b><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>This document provides information
about us and the legal terms and conditions (&quot;Terms&quot;) on which the
Vieunite services listed on our website (www.vieunite.com) and any associated
digital platform which may be released by us from time to time (together, the
                    &quot;Platform&quot;) are offered for you to make your Artwork available to
consumers and businesses via our Platform.</span><span lang="EN-GB"
                                                       style={{
                                                           fontSize: '12.0pt',
                                                           fontFamily: '"Times New Roman",serif',
                                                           msoFareastFontFamily: '"Times New Roman"',
                                                           msoFareastLanguage: 'EN-GB'
                                                       }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Introduction</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite provides a Platform for
Artists to make their Artwork available to businesses and consumers and
generate income.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>These Terms apply to any Artwork you
make available to Vieunite Users via the Platform, together with the associated
Artist Content and information required to set up an Artist Account, such as
your biography and profile picture. Please read these Terms carefully before
applying for and opening an Artist Account and each time you make Artwork
available through the Platform. By applying for and opening an Artist Account
and making Artwork available on the Platform, you agree to be bound by these
Terms and any general terms and conditions of use, which may be published on
the Platform from time to time.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Every time you wish to publish an
Artwork, please check these Terms, as we may have made changes to them since
your last upload. The Terms in force at the date of each order will apply. We
reserve the right to amend these Terms at any time.</span><span lang="EN-GB"
                                                                style={{
                                                                    fontSize: '12.0pt',
                                                                    fontFamily: '"Times New Roman",serif',
                                                                    msoFareastFontFamily: '"Times New Roman"',
                                                                    msoFareastLanguage: 'EN-GB'
                                                                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Contract Parties</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;We&quot;, &quot;us&quot;,
                    &quot;our&quot;, &quot;Vieunite&quot; are Vieunite Limited, a company
registered in England and Wales under company number 13883746, with our
registered office at </span><span lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>Allsee Building, 1 West Works Way, Longbridge Business Park, Birmingham,
B31 2JP</span><span lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;You,&quot; &quot;your,&quot; or
                    &quot;yours&quot; refers to the person who applies or is accepted as an Artist
on the Vieunite Platform.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>No terms under this document shall be
bound by the provisions under the Contracts (Rights of Third Parties) Act 1999
unless provisions hereinunder explicitly state otherwise.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;Account&quot; means our records
of any information you supplied to us.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;Artist&quot; means someone
Vieunite has accepted to publish their Artwork and Artist Content on our
Platform.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Artist Content” is all the material an
Artist provides for publication on the Platform. It includes a profile picture,
the Artist’s name, the Artist’s biography or statement, any other text, image,
or weblink provided by the Artist, and all Artwork and associated Artwork data
such as date of completion, media, title, price, etc. It does not include the
Artist’s email address or other personally sensitive data.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;Artwork&quot; is the digital
images made by the Artist and published through the Platform for Users to view.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '11.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '10.5pt',
                    fontFamily: 'Roboto',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoBidiFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Contract” means these General Terms and
Conditions, the Subscription Terms and Conditions, and other policies, such as
our Privacy Policy.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Code of Practice” means Vieunite Pro’s
code of practice detailing our method of dealing with any complaints or
disputes relating to our Products and Services, which can be found at
www.vieunite.com/business.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;Content&quot; means any text,
visual or other information, software, photos, video, graphics, sound and other
material appearing on or available through the Services for use on our Products
or otherwise, including any information supplied from time to time for which
Vieunite has the Rights to resell or allows a supplier of such Content to
provide them via our portal network.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Intellectual Property” or “IP” means
any intellectual property rights anywhere in the world, whether registerable or
not, including, without limitation, patents, trademarks, service marks,
designs, copyrights and related rights, database rights, know-how, moral rights
and domain names, as well as applications for registration of such rights and
the right to apply for registrations, and all equivalent or similar forms of
protection notwithstanding how they arise or in which media.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Platform” means the Vieunite and the
Vieunite Pro Platform, available through our website and web applications.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Privacy Policy” means the Vieunite
policy on controlling your information which can be found at
www.vieunite.com/business/privacy-policy.</span><span lang="EN-GB"
                                                      style={{
                                                          fontSize: '12.0pt',
                                                          fontFamily: '"Times New Roman",serif',
                                                          msoFareastFontFamily: '"Times New Roman"',
                                                          msoFareastLanguage: 'EN-GB'
                                                      }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>&quot;Rights&quot; means copyright,
trademark and other relevant proprietary and intellectual property rights
relating to Content.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Service” means the ability of an
Artist to publish Artwork and Artist Content through the Platform.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“User” means a business or consumer
using the Platform to access Artwork.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>“Vieunite Creative Commitment Fund” is
a mechanism for returning a basic income to Artists with a minimum of five
works in the Vieunite Pro Platform.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{
                    marginTop: '12.0pt',
                    marginRight: '0cm',
                    marginBottom: '12.0pt',
                    marginLeft: '0cm',
                    lineHeight: 'normal',
                    msoOutlineLevel: '3'
                }}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>How to Contact Us</span></b><b><span
                    lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>When we refer to &quot;in writing&quot;
                    in these Terms, this will include e-mail.</span><span lang="EN-GB"
                                                                          style={{
                                                                              fontSize: '12.0pt',
                                                                              fontFamily: '"Times New Roman",serif',
                                                                              msoFareastFontFamily: '"Times New Roman"',
                                                                              msoFareastLanguage: 'EN-GB'
                                                                          }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>If you have any questions or complaints
about the Platform or these Terms, these should be sent to us at
support@vieunite.com or by mail to Vieunite Limited at Allsee Building, 1 West
Works Way, Longbridge Business Park, Birmingham, B31 2JP. If we have to contact
you, we may do so by telephone, or by writing to you at the e-mail address or
postal address you have provided to us at the time you place your order.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Creating an Artist Account</span></b><b><span lang="EN-GB"
                                                                 style={{
                                                                     fontSize: '13.5pt',
                                                                     fontFamily: '"Times New Roman",serif',
                                                                     msoFareastFontFamily: '"Times New Roman"',
                                                                     msoFareastLanguage: 'EN-GB'
                                                                 }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Artists are accepted onto the
Vieunite Platform either by invitation or application. Vieunite is a curated
library, and we reserve the right to reject applications without providing a
reason. If you wish to make your work available through our Platform, you will
need to register and create an Account with us using the Platform.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>When you create an Account, you must
not:</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(a) Impersonate another individual;</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(b) Create ‘bot’ Accounts or any
Account which is controlled by other automated means; or</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(c) Share your password, give others
access to your account, or transfer your account to anyone else.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You agree to take measures to
maintain the security and secrecy of your Account username, password, and
Account information. You must notify us immediately of any breach of security
or unauthorised use of your Account that you become aware of.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You agree that you will be solely
responsible for all activity under your Account.</span><span lang="EN-GB"
                                                             style={{
                                                                 fontSize: '12.0pt',
                                                                 fontFamily: '"Times New Roman",serif',
                                                                 msoFareastFontFamily: '"Times New Roman"',
                                                                 msoFareastLanguage: 'EN-GB'
                                                             }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You confirm that the information you
provide when creating your Account is accurate and complete and that you will
update us via the Platform as and when your information changes.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>By setting up an Account, you confirm
that you are at least 18 years of age, not precluded by domestic laws from
using the Services, and have not been previously banned from using the Platform
and/or its Services.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>License</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>We grant you a revocable,
non-transferable, non-exclusive license to use the Platform, receive the
Services on your Devices, and make your Artwork available to Users, subject to
the terms of this Agreement, the Privacy Policy, and any other documents referred
to hereunder.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>For any reason, we may suspend,
terminate or withdraw your access to the Platform and Services without notice,
reason or liability to you.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Artist Content&nbsp;</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You accept that it is your sole
responsibility to ensure that your Artist Content is accurate, complete and
up-to-date.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You agree not to provide Artist
Content that is:</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(a) false, inaccurate or misleading;</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(b) in breach of any third-party
rights (including without limitation their Intellectual Property Rights, rights
to privacy, or rights to confidentiality);</span><span lang="EN-GB"
                                                       style={{
                                                           fontSize: '12.0pt',
                                                           fontFamily: '"Times New Roman",serif',
                                                           msoFareastFontFamily: '"Times New Roman"',
                                                           msoFareastLanguage: 'EN-GB'
                                                       }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(c) abusive or otherwise intended to
bully, harass, insult, intimate or humiliate; or</span><span lang="EN-GB"
                                                             style={{
                                                                 fontSize: '12.0pt',
                                                                 fontFamily: '"Times New Roman",serif',
                                                                 msoFareastFontFamily: '"Times New Roman"',
                                                                 msoFareastLanguage: 'EN-GB'
                                                             }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(d) defamatory, libellous, hateful,
violent, obscene, pornographic, unlawful, or otherwise offensive, as determined
by Vieunite in its sole discretion.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You represent and warrant that you
have all rights, permissions and consents to submit any Artist Content to us.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You agree that your Artwork and
Artist Content will be available to all Users.</span><span lang="EN-GB"
                                                           style={{
                                                               fontSize: '12.0pt',
                                                               fontFamily: '"Times New Roman",serif',
                                                               msoFareastFontFamily: '"Times New Roman"',
                                                               msoFareastLanguage: 'EN-GB'
                                                           }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>We have the right to disclose your
identity to any third party who is claiming that any Artist Content posted or
uploaded by you to our Services constitutes a violation of their rights,
including, without limitation, their Intellectual Property Rights, right to
privacy or confidentiality or is otherwise in breach of the terms of this
Agreement.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite may, but shall not be
obligated to, review, monitor, or remove your Artist Content at any time and
for any reason without notice.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Artists are responsible for
determining the sale price of Artist Content made available through the
Vieunite application. Vieunite retains a small proportion of the sale price to
cover Fees and VAT. The take-home price is clearly displayed in the Vieunite
Artist Portal.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Artist Content and Artwork uploaded
to the Platform may also be made available through the Vieunite Pro web portal.
Irrespective of the sale price for individual licenses in the Vieunite app,
revenue generated through Vieunite Pro is disbursed based on the display
timeshare for each item of Artwork. Vieunite returns 20% of the revenue
generated directly to the Artist’s account. 10% is retained for the Vieunite
Creative Commitment fund.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Every Artist with a minimum of five
works available for inclusion in the Vieunite Pro web portal receives an equal
share of the Vieunite Creative Commitment fund. In this way, the average amount
returned to an Artist is 30% of the revenue raised through this service.
However, the exact figure will depend on the performance of an artist’s Artist
Content in any given period.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Preloading and Demonstration Rights:</span></b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}> You grant Vieunite a non-exclusive
right to preload, store, and display selected Artwork on physical Vieunite
Products (including the Textura digital canvas) for the purposes of marketing,
public exhibition, retail demonstration, or inclusion in promotional prize
packages and televised giveaways. You acknowledge that such promotional
preloading does not constitute a &quot;sale&quot; or &quot;license&quot;
                    triggering the standard revenue-sharing model unless otherwise agreed in
writing.&nbsp;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite Pro</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite Pro is <span className="SpellE">Vieunite's</span>
business <span className="GramE">Platform <b>&nbsp;designed</b></span><b> for use in
environments such as hotels, retail shops, restaurants, offices, and other
commercial spaces. </b>&nbsp;This operates on a subscription basis, and
Vieunite provides curated image playlists to Users.</span><span lang="EN-GB"
                                                                style={{
                                                                    fontSize: '12.0pt',
                                                                    fontFamily: '"Times New Roman",serif',
                                                                    msoFareastFontFamily: '"Times New Roman"',
                                                                    msoFareastLanguage: 'EN-GB'
                                                                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite Pro is <span className="SpellE">Vieunite’s</span>
business Platform. This operates on a subscription basis, and Vieunite provides
curated image playlists to Users.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Although you may remove your Artwork
at any time from the Vieunite library, thereby making it immediately
inaccessible on the Vieunite app, you accept that there may be a delay of up to
three calendar months before the same image is removed from the Vieunite Pro
Platform.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You may opt out of Vieunite Pro
altogether, in which case you accept that you will receive no revenue via the
Vieunite Creative Commitment fund.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Unless you have chosen to opt-out,
you accept that Vieunite determines at our sole discretion whether Artist
Content shall be made available through Vieunite Pro.</span><span lang="EN-GB"
                                                                  style={{
                                                                      fontSize: '12.0pt',
                                                                      fontFamily: '"Times New Roman",serif',
                                                                      msoFareastFontFamily: '"Times New Roman"',
                                                                      msoFareastLanguage: 'EN-GB'
                                                                  }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Intellectual <span className="GramE">Property ,</span> Moral Rights, and
Marketing&nbsp;</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You warrant that you own and freely
control the Intellectual Property inherent in your Artwork and Artist Content.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite makes no intellectual
property claim to any Artist Content in the Library. You retain full Copyright
over your work.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You accept that Artwork and Artist
Content will be shared on the Platform.</span><span lang="EN-GB"
                                                    style={{
                                                        fontSize: '12.0pt',
                                                        fontFamily: '"Times New Roman",serif',
                                                        msoFareastFontFamily: '"Times New Roman"',
                                                        msoFareastLanguage: 'EN-GB'
                                                    }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You permit that Vieunite may share
without notice your Artist Content and your Artwork on our Social Media
accounts, and on the Social Media accounts associated with Vieunite, (i.e. the
professional Social Media accounts of senior employees and representatives) for
marketing purposes.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You permit Vieunite to share your
Artist Content and Artwork without notice on our <span className="GramE">Website</span>
and in any print or web media for marketing purposes.</span><span lang="EN-GB"
                                                                  style={{
                                                                      fontSize: '12.0pt',
                                                                      fontFamily: '"Times New Roman",serif',
                                                                      msoFareastFontFamily: '"Times New Roman"',
                                                                      msoFareastLanguage: 'EN-GB'
                                                                  }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;Marketing Adaptations and Moral
Rights:</span></b><span lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}> To ensure the effective promotion of the Platform and your Artwork, you
grant Vieunite the right to resize, crop, or otherwise adapt your Artwork to
fit specific marketing and technical formats (including varying aspect ratios
required for social media, digital displays, print, or broadcast). To the
extent permitted by law, you hereby waive your moral rights (including the
right of integrity) solely to permit these necessary technical and promotional
adaptations.&nbsp;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;Expanded Media Rights:</span></b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}> You permit Vieunite to share your
Artist Content and Artwork on our Social Media accounts, our <span className="GramE">Website</span>,
and <span className="GramE">in <b>&nbsp;all</b></span><b> forms of broadcast media,
including television and <span className="GramE">film, <span style={{fontWeight: 'normal'}}>&nbsp;for</span></span></b>
marketing and promotional purposes without notice. This includes use in
promotional partnerships, product placements, and televised giveaway
segments.&nbsp;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;Broadcast Clearance Warranty:</span></b><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}> You warrant that all Artwork
provided is cleared for worldwide broadcast and public performance/exhibition,
and that its use by Vieunite or its promotional partners will not require any
additional payments to third parties, guilds, or collecting societies.&nbsp;</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Acceptable Use Restrictions</span></b><b><span lang="EN-GB"
                                                                  style={{
                                                                      fontSize: '13.5pt',
                                                                      fontFamily: '"Times New Roman",serif',
                                                                      msoFareastFontFamily: '"Times New Roman"',
                                                                      msoFareastLanguage: 'EN-GB'
                                                                  }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>As a condition of being granted access
to the Platform and the Services you agree:</span><span lang="EN-GB"
                                                        style={{
                                                            fontSize: '12.0pt',
                                                            fontFamily: '"Times New Roman",serif',
                                                            msoFareastFontFamily: '"Times New Roman"',
                                                            msoFareastLanguage: 'EN-GB'
                                                        }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(a) not to (or attempt to) circumvent,
disable or otherwise interfere with any security-related features of the
Service or features that enforce limitations on use of the Service or the
Content;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(b) not to launch any automated system
(including, without limitation, any robot, spider or offline reader) that
accesses the Services in a manner that sends more request messages to the
Vieunite servers in a given period of time than a human can reasonably produce
in the same period by using a publicly available, standard web browser;</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(c) not to submit or transmit any
material, including Artist Content, that is unlawful, in breach of third-party
rights, inaccurate, false, defamatory, offensive or otherwise objectionable in
relation to your use of the Platform or any Service;</span><span lang="EN-GB"
                                                                 style={{
                                                                     fontSize: '12.0pt',
                                                                     fontFamily: '"Times New Roman",serif',
                                                                     msoFareastFontFamily: '"Times New Roman"',
                                                                     msoFareastLanguage: 'EN-GB'
                                                                 }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(d) not to use the Platform or Service
for any unlawful purpose, or in any manner inconsistent with this Agreement, or
act fraudulently or maliciously, for example, by hacking into or inserting
malicious code, including viruses, or harmful data, into the Platform, any
Service or any operating system;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(e) not to use the Platform or Service
to offer, solicit, arrange, or engage in, any kind of activity or arrangement
which is, or which would be unlawful;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(f) not to infringe our rights or those
of any third party in relation to your use of the Platform or any Service (to
the extent that such use is not expressly licensed by this Agreement);</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(g) not to use the Platform or Service
in a way that could damage, disable, overburden, impair or compromise our
systems or security or interfere with other Artists and Users; and</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>(h) not to collect, extract or harvest
any information or data from the Platform, any Service or our systems or
attempt to decipher any transmissions to or from the servers running any
Service.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '0cm', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}>&nbsp;</span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Termination of Agreement</span></b><b><span lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(a) notifying Vieunite; and</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(b) closing your Account.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You understand and accept that it may
take up to three calendar months to remove your work from the Vieunite Pro
Platform.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Without prejudice to our rights
hereunder, we may terminate this Agreement immediately without notice to you:</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(a) if you commit a breach of this
Agreement which you fail to remedy (if remediable) within three days after
being notified to do so;</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(b) if you breach any of the License
Restrictions or the Acceptable Use Restrictions;</span><span lang="EN-GB"
                                                             style={{
                                                                 fontSize: '12.0pt',
                                                                 fontFamily: '"Times New Roman",serif',
                                                                 msoFareastFontFamily: '"Times New Roman"',
                                                                 msoFareastLanguage: 'EN-GB'
                                                             }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(c) if we have any reason to suspect
that your use of the Platform and/or Services is unlawful, or that it would
bring us and/or other Artists and/or Users or the Platform into disrepute;</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(d) if we believe that we are
required to terminate your use of the Platform and/or Services by law or any
instruction of a regulator or other body with competent authority; or</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>(e) if we withdraw the Platform from
service, or otherwise reorganise or restructure our business so as to
necessitate the termination or suspension of provision of the Platform to you.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Without prejudice to our rights
hereunder, we may terminate this Agreement, or generally cease offering or deny
access to the Platform and Services or any portion thereof, at any time for any
or no reason whatsoever, immediately by notifying you in writing.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '6.0pt', lineHeight: 'normal', msoOutlineLevel: '3'}}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Information Security&nbsp;</span></b><b><span lang="EN-GB"
                                                                 style={{
                                                                     fontSize: '13.5pt',
                                                                     fontFamily: '"Times New Roman",serif',
                                                                     msoFareastFontFamily: '"Times New Roman"',
                                                                     msoFareastLanguage: 'EN-GB'
                                                                 }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Vieunite Limited is committed to
ensuring the security of your personal information and data on the Vieunite Pro
Portal. We implement a variety of security measures to maintain the safety of
your personal data. These measures include:</span><span lang="EN-GB"
                                                        style={{
                                                            fontSize: '12.0pt',
                                                            fontFamily: '"Times New Roman",serif',
                                                            msoFareastFontFamily: '"Times New Roman"',
                                                            msoFareastLanguage: 'EN-GB'
                                                        }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Encryption Standards: All data
transmitted to and from our servers is encrypted using industry-standard
encryption protocols to ensure its confidentiality and integrity.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Access Controls: We implement strict
access control mechanisms to ensure that only authorized personnel have access
to sensitive information. Access is granted based on roles and
responsibilities, and is regularly reviewed.</span><span lang="EN-GB"
                                                         style={{
                                                             fontSize: '12.0pt',
                                                             fontFamily: '"Times New Roman",serif',
                                                             msoFareastFontFamily: '"Times New Roman"',
                                                             msoFareastLanguage: 'EN-GB'
                                                         }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Regular Security Audits: Vieunite Pro
undergoes regular security audits to identify and mitigate potential
vulnerabilities in our systems. These audits are conducted by third-party
security experts to ensure unbiased assessments.</span><span lang="EN-GB"
                                                             style={{
                                                                 fontSize: '12.0pt',
                                                                 fontFamily: '"Times New Roman",serif',
                                                                 msoFareastFontFamily: '"Times New Roman"',
                                                                 msoFareastLanguage: 'EN-GB'
                                                             }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Compliance with Information Security
Standards: Our servers adhere to the international standard ISO/IEC 27001:2022,
27017:2015, 27018:2019, 27701:2019, 22301:2019, 20000-1:2018, 9001:2015, and
CSA STAR CCM v4.0 for information security management systems, ensuring
comprehensive and effective security practices.</span><span lang="EN-GB"
                                                            style={{
                                                                fontSize: '12.0pt',
                                                                fontFamily: '"Times New Roman",serif',
                                                                msoFareastFontFamily: '"Times New Roman"',
                                                                msoFareastLanguage: 'EN-GB'
                                                            }}></span></p>

                <p className="MsoNormal" style={{
                    marginTop: '12.0pt',
                    marginRight: '0cm',
                    marginBottom: '12.0pt',
                    marginLeft: '0cm',
                    lineHeight: 'normal',
                    msoOutlineLevel: '3'
                }}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Protection&nbsp;</span></b><b><span
                    lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>We are dedicated to protecting your
personal data in accordance with the EU General Data Protection Regulation
(GDPR) as well as the UK Data Protection Act 2018. Our data protection policies
include:</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Lawful Basis for Processing: We
ensure that personal data is processed lawfully, fairly, and in a transparent
manner. Data is collected and used for specified, explicit, and legitimate
purposes.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Subject Rights: You have the
right to access, rectify, erase, restrict, and object to the processing of your
personal data. To exercise these rights, you can contact our Data Protection
Officer at support@vieunite.com. Requests will be handled promptly and in
accordance with applicable regulations.</span><span lang="EN-GB"
                                                    style={{
                                                        fontSize: '12.0pt',
                                                        fontFamily: '"Times New Roman",serif',
                                                        msoFareastFontFamily: '"Times New Roman"',
                                                        msoFareastLanguage: 'EN-GB'
                                                    }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Minimisation: We collect only
the data that is necessary for the purposes for which it is processed. Personal
data is kept accurate and up to date.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Retention: Personal data is
retained only for as long as necessary to <span className="SpellE">fulfill</span> the
purposes for which it was collected and processed, and as required by
applicable laws.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Security: We employ technical
and organizational measures to ensure the security of personal data, including
encryption, access controls, and regular security testing.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>User Consent Procedures: We obtain
and document user consent where required for data processing activities,
ensuring compliance with UK DPA 2018 and GDPR requirements.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Third-Party Processors: Any
third-party service providers are Financial Conduct Authority (FCA)-compliant
and process personal data on our behalf are subject to stringent data
protection obligations to ensure the security and confidentiality of your data.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>International Transfers: If personal
data is transferred outside the European Economic Area (EEA), we ensure that
adequate safeguards are in place, such as standard contractual clauses or
binding corporate rules.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Data Breach Notification: In the
event of a data breach that poses a risk to your rights and freedoms, we will
notify you and the relevant supervisory authority without undue delay.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>For any inquiries regarding our data
protection policies, please contact our Data Protection Officer at
support@vieunite.com.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{
                    marginTop: '12.0pt',
                    marginRight: '0cm',
                    marginBottom: '12.0pt',
                    marginLeft: '0cm',
                    lineHeight: 'normal',
                    msoOutlineLevel: '3'
                }}><b><span
                    lang="EN-GB" style={{
                    fontSize: '14.0pt',
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: 'black',
                    msoFareastLanguage: 'EN-GB'
                }}>Other Important Terms</span></b><b><span
                    lang="EN-GB" style={{
                    fontSize: '13.5pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></b></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>You can go to court. These terms are
governed by English law and wherever you live you can bring claims against us
in the English courts. If you live in Wales, Scotland or Northern Ireland, you
can also bring claims against us in the courts of the country you live in.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Contract transfer. We can transfer
our Contract with you, so that a different organisation is responsible for
supplying your product. We'll tell you in writing if this happens. You can only
transfer your Contract with us to someone else if we agree to this.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Nobody else has any rights under each
Contract. Each Contract is between you and us. Nobody else can enforce it and
neither of us will need to ask anybody else to sign-off on ending or changing
it.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Even if we delay, we might not
immediately chase you for not doing something (like paying) or for doing
something you're not allowed to, but that doesn’t mean we cannot do it later.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Intellectual Property Rights:
Vieunite owns all legal rights, title and interest in and to the Vieunite
Platforms. Nothing in these Terms and Conditions of Use shall be construed to
fully or partially assign any such rights, titles and interests to the users,
save for what is required for the purposes of publishing the curated artworks
and playlists. These Terms and Conditions of Use only give you a corporate
worldwide, non-assignable and non-exclusive license to use the Vieunite Pro
Portal.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Without prejudice to your right under
statutory law within your jurisdiction, UK or otherwise, <span className="GramE">You</span>
may not copy, modify, reproduce, create a derivative work of, reverse engineer,
decompile, or otherwise attempt to extract the source code of the software
running on the Vieunite Pro Portal. Manipulating or changing the Portal or its
content therein in any way, or providing links to or from the Portal without <span
                        className="SpellE">Vieunite’s</span> explicit consent is prohibited.</span><span
                    lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Nothing in these Terms and Conditions
gives you the right to use <span className="SpellE">Vieunite’s</span> trade names,
trademarks, service marks, logos, domain names etc.</span><span lang="EN-GB"
                                                                style={{
                                                                    fontSize: '12.0pt',
                                                                    fontFamily: '"Times New Roman",serif',
                                                                    msoFareastFontFamily: '"Times New Roman"',
                                                                    msoFareastLanguage: 'EN-GB'
                                                                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Limitation of Liability: Vieunite
does not store content which it has not legally obtained. Third party content
owners (i.e., onboarded Vieunite Artists) are solely responsible for the
quality and continuity of the artworks put on the Vieunite Pro Artwork
Marketplace. Vieunite is in no way liable for any content provided by third
party content owners. Your access to content provided by these <span
                        className="GramE">third party</span> content owners is done at your own risk, with
the understanding that you may be exposed to content which you may find
offensive, or objectionable. The artworks provided on the Vieunite Pro Artwork
Marketplace are provided “As Is” and “As Available”. Accordingly, Vieunite
disclaims all liability as regards the accuracy, completeness and reliability
of any third-party content.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>TO THE EXTENT ALLOWED BY APPLICABLE
LAW, VIEUNITE SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES WHICH MAY BE INCURRED BY YOU AS A
RESULT OF THE USE OF VIEUNITE PRO PORTAL, <span style={{msoTabCount: '1'}}>          </span>THE
VIEUNITE ARTIST PORTAL, OR THE VIEUNITE HOME APP INCLUDING BUT NOT LIMITED TO
LOSS OF PROFIT, LOSS OF BUSINESS GOODWILL OR REPUTATION, COST OF PROCUREMENT OF
SUBSTITUTE GOOD OR SERVICES ETC. FURTHERMORE, VIEUNITE DISCLAIMS ALL WARRANTIES
AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
LIMITED TO IMPLIED WARRANTIES AND CONDITIONS OF MERCHANGTABILITY, FITNESS FOR A
PARTICULAR PURPOSE ETC, SAVE FOR WHATEVER IS PROVIDED FOR UNDER STATUTORY LAW
IN THE JURISDICTION OF THE USER.</span><span lang="EN-GB" style={{
                    fontSize: '12.0pt',
                    fontFamily: '"Times New Roman",serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    msoFareastLanguage: 'EN-GB'
                }}></span></p>

                <p className="MsoNormal" style={{marginBottom: '12.0pt', lineHeight: 'normal'}}><span
                    lang="EN-GB" style={{
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: '#1F1F1F',
                    msoFareastLanguage: 'EN-GB'
                }}>Any disputes arising out of these
Terms and Conditions will be governed by and interpreted in accordance with the
laws of England and Wales. If You choose to bring proceedings in connection
with these Terms and Conditions, <span className="GramE">You</span> must do so in the
courts of England Wales, unless You live in Scotland or Northern Ireland, in
which case You can choose to bring proceedings there.</span><span lang="EN-GB"
                                                                  style={{
                                                                      fontSize: '12.0pt',
                                                                      fontFamily: '"Times New Roman",serif',
                                                                      msoFareastFontFamily: '"Times New Roman"',
                                                                      msoFareastLanguage: 'EN-GB'
                                                                  }}></span></p>

                <p className="MsoNormal"><span lang="EN-GB">&nbsp;</span></p>

            </div>

        </div>
    );
}

export default ArtistsTermsAndConditions;
